import { ComponentProps } from 'react';

import { cx } from '@/ui/cva';
import { Icon } from '@/ui/Icon';

export function StoryVideoButton(props: ComponentProps<'button'>) {
    return (
        <button
            {...props}
            type="button"
            className={cx(
                'group/play-button absolute inset-0 select-none rounded-xl outline-none',
                'focus-visible:outline-2 focus-visible:-outline-offset-4 focus-visible:outline-blue'
            )}
        >
            <div
                className={cx(
                    'absolute inset-0 flex items-center justify-center',
                    'before:absolute before:aspect-[16/9] before:w-2xl before:rounded-full before:bg-black/30 before:transition-all',
                    'hover:before:w-full hover:before:rounded-none hover:before:md:w-full hover:before:lg:w-full'
                )}
            >
                <Icon className="relative text-5xl text-white transition group-hover/play-button:scale-110">
                    play_arrow
                </Icon>
            </div>
        </button>
    );
}
